<template>
  <a-form
    layout="horizontal"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :colon="false"
    :form="form"
  >
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="企业名称">
          <a-input
            size="large"
            placeholder="请输入企业名称"
            v-decorator="[
              'registerAgentInfo.chiName',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
            :disabled="type === 'modify'"
          >
          </a-input>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item required label="企业类型">
          <a-select
            size="large"
            placeholder="请选择企业类型"
            v-decorator="[
              'registerAgentInfo.agentType',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
            <a-select-option value="AGENT">旅行社</a-select-option>
            <a-select-option value="TRAVEL">代理人</a-select-option>
            <a-select-option value="CORP">机构客户</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="业务员联系人">
          <a-input
            size="large"
            placeholder="请输入业务员联系人姓名"
            v-decorator="[
              'registerAgentInfo.contactName',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item required label="所属营业部">
          <a-input
            size="large"
            placeholder="请输入所属营业部"
            v-decorator="[
              'registerAgentInfo.department',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="OFFICE号">
          <a-input
            size="large"
            placeholder="请输入航办office号"
            v-decorator="[
              'registerAgentInfo.officeNo',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
      <a-col :md="12" :sm="24">
        <a-form-item label="办公电话">
          <a-input
            size="large"
            placeholder="请输入有效办公联系电话"
            v-decorator="[
              'registerAgentInfo.phoneNo',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
          </a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <a-row>
      <a-col :md="12" :sm="24">
        <a-form-item required label="国家/地区">
          <a-cascader
            allow-clear
            :options="options"
            :load-data="loadData"
            placeholder="国家/省/市"
            change-on-select
            size="large"
            v-decorator="[
              'registerAgentInfo.country',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { find } from 'lodash'
import { validate } from '@/utils/validate'
import { getCountry, getProvince, getCity } from '@/api/data'

const verifyItems = {
  'registerAgentInfo.officeNo': 102
}

export default {
  props: {
    type: {
      type: String,
      default: 'new'
    }
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      form: this.$form.createForm(this),
      options: [],
      defaultOptionsValue: []
    }
  },
  created () {
    this.fetchCountry()
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('agent-company', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        const idx = verifyItems[rule.fullField]

        if (!error && idx && value) {
          return this.$emit('verify', value, idx, callback)
        }

        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    async fetchCountry () {
      try {
        const data = await getCountry('id')

        this.options = data
        this.initCityDefaultSelected()
      } catch (err) {
        this.$message.error({
          content: err.message,
          centered: true
        })
      }
    },
    async loadData (selectedOptions) {
      const len = selectedOptions.length
      const targetOption = selectedOptions[len - 1]
      targetOption.loading = true

      const fun = len === 1 ? getProvince : getCity
      const data = await fun(targetOption.id)
      targetOption.loading = false
      targetOption.children = data
      this.options = [...this.options]
    },
    modifyInit (city) {
      this.defaultOptionsValue = city
    },
    async initCityDefaultSelected () {
      const { options, defaultOptionsValue } = this
      const len = defaultOptionsValue.length

      if (len > 1) {
        const selected = []

        for (let i = 0; i < len - 1; i++) {
          const city = find(i === 0 ? options : selected[i - 1].children, { value: defaultOptionsValue[i] })

          if (city) {
            selected.push(city)
            await this.loadData(selected)
          }
        }
      }
    }
  }
}
</script>
